import { getCode } from './get-code.util';
import { Key, Shortcut } from './shortcut.model';

const IS_MAC_OS = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

export function isShortcutPressed(shortcut: Shortcut, event: KeyboardEvent): boolean {
  const keys = shortcut.split('+');

  return [
    event.code === getCode(keys[keys.length - 1] as Key),
    event.altKey === keys.includes('alt'),
    event.ctrlKey === (keys.includes('ctrl') && !IS_MAC_OS),
    event.metaKey === (keys.includes('ctrl') && IS_MAC_OS || keys.includes('cmd')),
    event.shiftKey === keys.includes('shift'),
  ].every(Boolean);
}
